<div class="kReleaseNotes">
  <p class="kTitle">Welcome to KMC-NG version 0.1.0 release!</p>
  <iframe
    src="http://cdnapi.kaltura.com/p/1645161/sp/164516100/embedIframeJs/uiconf_id/37095171/partner_id/1645161?iframeembed=true&playerId=kaltura_player_1485857274&entry_id=1_1n4wcz4c&flashvars[streamerType]=auto"
    width="640"
    height="395"
    allowfullscreen
    webkitallowfullscreen
    mozAllowFullScreen
    frameborder="0"
  ></iframe>
  <p>
    <p-checkbox
      label="Don't show this again"
      [(ngModel)]="_showReleaseNotes"
      (onChange)="_toggleReleaseNotes($event)"
      binary="true"
    ></p-checkbox>
  </p>
</div>
